export default "__VITE_ASSET__9da48e85__"